import Component from '@glimmer/component';
import { service } from '@ember/service';
import { LinkTo } from '@ember/routing';
import { VStack, Section } from 'tio-ui/components/layout';
import { Heading, Text } from 'tio-ui/components/typography';
import { Button } from 'tio-ui/components/buttons';
import { t } from 'ember-intl';
import DataIndicator from 'tio-employee/components/reimagined/data-indicator';
import type { DataSource } from 'tio-employee/components/reimagined/data-indicator';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';
import type { DataSourceInfo, LiveTasData } from 'tio-employee/services/reimagined-data';

interface TasApplicationTypeThreeModel {
  tasData: LiveTasData;
  tasUsedAmount: { yearToDate: number; isLiveData: boolean };
  dataSourceInfo: DataSourceInfo;
  applicationId: string;
  applicationType: string;
}

interface TasApplicationTypeThreeSignature {
  Args: {
    model: TasApplicationTypeThreeModel;
  };
}

export default class CareerPathwaysTasApplicationTypeThreeNew extends Component<TasApplicationTypeThreeSignature> {
  @service declare reimaginedData: ReimaginedDataService;

  get isDemoMode() {
    return this.reimaginedData.isDemoMode;
  }

  get tasSource(): DataSource {
    if (this.isDemoMode) return 'demo';
    return this.args.model.tasData.isLiveData ? 'live' : 'placeholder';
  }

  <template>
    <VStack class="gap-6">
      <div class="flex flex-col gap-2">
        <Heading @level={{1}}>{{t "common.start"}}</Heading>
        <Text @intent="muted">{{t "tuition_assistance.default"}}</Text>
      </div>

      <DataIndicator
        @source={{this.tasSource}}
        @showBadge={{true}}
        @dataSourceId="tas-application-type-three-new"
      >
        <Section>
          <:header>
            <Heading @level={{2}}>{{t "common.get_started"}}</Heading>
          </:header>
          <:body>
            <Text @intent="muted">{{t "tas.dashboard.eligible_benefits"}}</Text>
            <div class="mt-4">
              <LinkTo
                @route="authenticated.tas.applications.type-three.new"
                @model={{@model.applicationId}}
              >
                <Button @intent="primary">{{t "common.start"}}</Button>
              </LinkTo>
            </div>
          </:body>
        </Section>
      </DataIndicator>
    </VStack>
  </template>
}
